import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import NavbarFixed from "../components/NavbarFixed";
import NavbarAbs from "../components/NavbarAbs";
import Footer from "../components/Footer"
import LoadingPage from "../components/home/LoadingPage";
import Intro from "../components/home/Intro";
import ScrollDown from "../components/ScrollDown";
import InfoSection from "../components/home/InfoSection";
import { Helmet } from "react-helmet";

const Home = () => {
  const [isNavVisible, setNavVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [hasLoaded, setHasLoaded] = useState(false); // To control animations start

  const handleLoading = () => {
    setTimeout(() => {
      setHasLoaded(true);
      setIsLoading(false);
    }, 1200); // Add delay to let animations kick in
  };

  useEffect(() => {
    if (window.scrollY > 120 || window.innerWidth < 900) {
      setNavVisible(true); // Show if scroll position is past the threshold or if window width is less than 800px
    } else {
      setNavVisible(false); // Hide if scroll position is above the threshold and window width is 800px or greater
    }

    setTimeout(() => {
      setHasLoaded(true);
      setIsLoading(false);
    }, 1200); // Add delay to let animations kick in
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      // Check if the scroll position is past 120px or if window width is less than 800px
      if (window.scrollY > 120 || window.innerWidth < 900) {
        setNavVisible(true); // Show if scroll position is past the threshold or if window width is less than 800px
      } else {
        setNavVisible(false); // Hide if scroll position is above the threshold and window width is 800px or greater
      }
    };

    // Attach the event listener on mount
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll); // Listen to window resize events as well
    window.addEventListener("load", handleLoading);

    // Cleanup the event listener on unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll); // Cleanup resize listener
      window.removeEventListener("load", handleLoading);
    };
  }, []);

  return (
    <>
      {isLoading && <LoadingPage />}

      {!isLoading && (
        <motion.div
          className="fade-in overflow-x-hidden bg-slate-700" // Prevent horizontal overflow
          initial={{ opacity: 0 }}
          animate={{ opacity: hasLoaded ? 1 : 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          <Helmet>
            <title>moses.zhang.home</title>
          </Helmet>
          <NavbarAbs visible={!isNavVisible} />
          <NavbarFixed visible={isNavVisible} />

          <div className="w-full">
            <Intro />
            <InfoSection />
            <Footer />
          </div>
          <ScrollDown delay={2.4} />
        </motion.div>
      )}
    </>
  );
};

export default Home;
